import React, { useEffect, useState } from "react";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import SearchInput from "../../../core/Inputs/SearchInput";
import debounce from "lodash.debounce";

export default function RoiReports() {
  const apiUrl = process.env.REACT_APP_NODE_API_URL;
  const frontUrl = process.env.REACT_APP_USER_LINK;
  const { id } = useParams();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [roiName, setRoiName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const getReports = async () => {
    try {
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi-submit-data/getByRoi/${id}`,
        ""
      );
      if (response.data?.statusCode === 200 && response.data?.result === "success") {
        setData(response.data?.data || []);
      }
    } catch (error) {
      toast.error("Failed to load reports.");
    }
  };

  useEffect(() => {
    getReports();
    const fetchRoiDetail = async () => {
      try {
        const response = await performHttpRequest(
          "GET",
          `${apiUrl}/roi/getRoiDetail/${id}`,
          ""
        );
        if (response.data?.statusCode === 200 && response.data?.result === "success") {
          setRoiName(response.data.data.roi_name);
        }
      } catch (error) {
        // ignore
      }
    };
    if (id) fetchRoiDetail();
  }, [id]);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleSearch = debounce((inputValue) => {
    setSearchQuery(inputValue);
    if (inputValue.trim() !== "") {
      const filtered = data.filter((item) => {
        const dateStr = item?.add_date_time || "";
        return dateStr.toLowerCase().includes(inputValue.toLowerCase());
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, 300);

  const handleClear = () => {
    setSearchQuery("");
    setFilteredData(data);
  };

  const parseCurrency = (currencySymbolRaw) => {
    try {
      const parsed = JSON.parse(currencySymbolRaw);
      return parsed?.currencySymbol || "-";
    } catch {
      return currencySymbolRaw || "-";
    }
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleViewReport = (row) => {
    const submissionId = row?.roi_submitted_data_id || id;
    window.open(`${frontUrl}/roi/${id}/report/${submissionId}`, "_blank");
  };

  const columns = [
    {
      name: "Date Submitted",
      sortable: true,
      sortField: "add_date_time",
      selector: (row) => row.add_date_time,
      cell: (row) => (
        <div className="w-100">
          <span className="surv-title">{formatDateTime(row.add_date_time)}</span>
        </div>
      ),
    },
    {
      name: "Currency",
      sortable: false,
      cell: (row) => (
        <div className="text-center w-100">
          <span>{parseCurrency(row.currency_symbol)}</span>
        </div>
      ),
    },
    {
      name: "",
      width: "140px",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleViewReport(row)}
          type="button"
        >
          View Report
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <div className="dashboard-page-outer flex-grow-1">
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin/roi" className="home-item" title="Dashboard">
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/roi">Calculator</Link>
                    </li>
                    {roiName && (
                      <li className="breadcrumb-item">
                        <Link to={`/admin/roi/${id}`}>{roiName}</Link>
                      </li>
                    )}
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>All Reports</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="dashboard-page-wrap">
                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center surveyfilter">
                    <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder="Search by date"
                        onSearch={handleSearch}
                        onClear={handleClear}
                        fill={true}
                      />
                    </div>
                  </div>
                  <div className="tablePage bg-white">
                    <div className="content-table survey-table survey-table-height">
                      <div className="data-table-wrap custom-data-table first-check">
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          pagination
                          noDataComponent={
                            <div className="p-4 text-center text-muted">
                              No reports submitted yet.
                            </div>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
